import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { playbackUrl: String }

  play(event) {
    event.preventDefault()

    const url = this.playbackUrlValue
    if (!url) return

    // Keep the thumbnail markup so we can restore it if the source fails to load.
    const original = this.element.innerHTML

    const player = document.createElement("video")
    player.src = url
    player.controls = true
    player.autoplay = true
    player.playsInline = true
    player.className = "video-player"
    player.addEventListener("error", () => {
      this.element.classList.remove("is-playing")
      this.element.innerHTML = original
    })

    // is-playing lets CSS break the player out of the fixed thumbnail box.
    this.element.classList.add("is-playing")
    this.element.innerHTML = ""
    this.element.appendChild(player)
    // Autoplay may be rejected by browser policy; controls let the user start manually.
    player.play().catch((error) => console.warn("[feedback-video] autoplay blocked", error))
  }
}
